import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

import { MaterialModule } from "./material.module";
import { FaLibraryModule } from "./fa-library.module";

import { TooltipComponent } from './components/tooltip/tooltip.component';

@NgModule({
    declarations: [
        TooltipComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FaLibraryModule,
        FormsModule,
        TranslateModule
    ],
    exports: [
        MaterialModule,
        FaLibraryModule,
        TranslateModule,
        FontAwesomeModule,
        TooltipComponent
    ]
})
export class SharedModule {}
